import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RecordsService } from '../services/records.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  public lang: String = 'ar';

  constructor(public recordService: RecordsService, public router: Router, public translate: TranslateService) {
    translate.onLangChange.subscribe(() => {
      if(this.lang) this.lang = translate.currentLang;
    });
  }

  ngOnInit(): void {
    
  }

}
